import script from "./BookSelection16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookSelection16167.vue?vue&type=script&setup=true&lang=ts"

import "./BookSelection16167.vue?vue&type=style&index=0&id=2c1de9d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1de9d8"]])

export default __exports__